/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "catalogmigrator": {
        "nested": {
          "common": {
            "nested": {
              "CatalogType": {
                "values": {
                  "CATALOG_TYPE_UNKNOWN": 0,
                  "CATALOG_TYPE_MENU": 1,
                  "CATALOG_TYPE_RETAIL": 2
                }
              },
              "ImportProvider": {
                "values": {
                  "IMPORT_PROVIDER_UNKNOWN": 0,
                  "IMPORT_PROVIDER_WOFLOW_LINK_UPLOAD": 1,
                  "IMPORT_PROVIDER_WOFLOW_LINK_MIGRATION": 2
                }
              },
              "Error": {
                "values": {
                  "ERROR_UNKNOWN": 0,
                  "ERROR_NOT_ACCEPTING_MENU_MIGRATIONS": 1
                }
              },
              "Status": {
                "values": {
                  "STATUS_UNKNOWN": 0,
                  "STATUS_SUCCESS": 1,
                  "STATUS_FAILURE": 2
                }
              },
              "PrepareMigrationResponse": {
                "fields": {
                  "woflowJwt": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "catalogImportToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "StartMigrationResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.catalogmigrator.common.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": "squareup.catalogmigrator.common.Error",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "UpdateAdditionalAttributesResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.catalogmigrator.common.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "error": {
                    "type": "squareup.catalogmigrator.common.Error",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "MenuAttributes": {
                "fields": {
                  "menuName": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "isOmnichannel": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  },
                  "unitTokens": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "channelIds": {
                    "type": "string",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "availabilityPeriodIds": {
                    "type": "string",
                    "id": 5,
                    "rule": "repeated"
                  },
                  "onlineChannelsVisible": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  }
                }
              },
              "RetailAttributes": {
                "fields": {}
              },
              "HealthAndBeautyAttributes": {
                "fields": {}
              },
              "StaffAttributes": {
                "fields": {}
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.CatalogType && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.ImportProvider && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.Error && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.Status && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.PrepareMigrationResponse && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.StartMigrationResponse && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.UpdateAdditionalAttributesResponse && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.MenuAttributes && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.RetailAttributes && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.HealthAndBeautyAttributes && !$root.nested?.squareup?.nested?.catalogmigrator?.nested?.common?.nested?.StaffAttributes) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CatalogType @ squareup/catalogmigrator/common.proto at 9:1
 */
export const CatalogType = $root.lookupEnum('squareup.catalogmigrator.common.CatalogType').values;
/**
 * SOURCE ImportProvider @ squareup/catalogmigrator/common.proto at 15:1
 */
export const ImportProvider = $root.lookupEnum('squareup.catalogmigrator.common.ImportProvider').values;
/**
 * SOURCE Error @ squareup/catalogmigrator/common.proto at 33:1
 */
export const Error = $root.lookupEnum('squareup.catalogmigrator.common.Error').values;
/**
 * SOURCE Status @ squareup/catalogmigrator/common.proto at 38:1
 */
export const Status = $root.lookupEnum('squareup.catalogmigrator.common.Status').values;
/**
 * SOURCE PrepareMigrationResponse @ squareup/catalogmigrator/common.proto at 45:1
 */
export const PrepareMigrationResponse = $root.lookupType('squareup.catalogmigrator.common.PrepareMigrationResponse');
fixType(PrepareMigrationResponse);
Builder.createAndAttachToType(PrepareMigrationResponse);
/**
 * SOURCE StartMigrationResponse @ squareup/catalogmigrator/common.proto at 50:1
 */
export const StartMigrationResponse = $root.lookupType('squareup.catalogmigrator.common.StartMigrationResponse');
fixType(StartMigrationResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(StartMigrationResponse);
/**
 * SOURCE UpdateAdditionalAttributesResponse @ squareup/catalogmigrator/common.proto at 55:1
 */
export const UpdateAdditionalAttributesResponse = $root.lookupType('squareup.catalogmigrator.common.UpdateAdditionalAttributesResponse');
fixType(UpdateAdditionalAttributesResponse, {
  status: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateAdditionalAttributesResponse);
/**
 * SOURCE MenuAttributes @ squareup/catalogmigrator/common.proto at 60:1
 */
export const MenuAttributes = $root.lookupType('squareup.catalogmigrator.common.MenuAttributes');
fixType(MenuAttributes, {
  menuName: {
    required: true
  },
  unitTokens: {
    required: true
  }
});
Builder.createAndAttachToType(MenuAttributes);
/**
 * SOURCE RetailAttributes @ squareup/catalogmigrator/common.proto at 69:1
 */
export const RetailAttributes = $root.lookupType('squareup.catalogmigrator.common.RetailAttributes');
fixType(RetailAttributes);
Builder.createAndAttachToType(RetailAttributes);
/**
 * SOURCE HealthAndBeautyAttributes @ squareup/catalogmigrator/common.proto at 73:1
 */
export const HealthAndBeautyAttributes = $root.lookupType('squareup.catalogmigrator.common.HealthAndBeautyAttributes');
fixType(HealthAndBeautyAttributes);
Builder.createAndAttachToType(HealthAndBeautyAttributes);
/**
 * SOURCE StaffAttributes @ squareup/catalogmigrator/common.proto at 77:1
 */
export const StaffAttributes = $root.lookupType('squareup.catalogmigrator.common.StaffAttributes');
fixType(StaffAttributes);
Builder.createAndAttachToType(StaffAttributes);